import React, {useRef} from 'react';
import clsx from 'clsx';

import useOnClickOutside from '../../../../website-ui/hooks/use-click-outside';
import {AVAILABLE_REACTION_LIST, REACTION_ICON_SIZES} from '../constants';

import Reaction from './reaction';

import styles from '../reactions.module.css';

const AvailableReactions = ({
  onClose,
  onReactionClick,
  commentReactionsLength
}) => {
  const rootRef = useRef(null);

  useOnClickOutside(rootRef, onClose);

  return (
    <div
      className={clsx(
        styles.availableReactions,
        styles[`availableReactionsPosition${commentReactionsLength}`])
      }
      ref={rootRef}
    >
      {AVAILABLE_REACTION_LIST.map(reactionType => (
        <Reaction
          type={reactionType}
          key={reactionType}
          size={REACTION_ICON_SIZES.LARGE}
          onClick={() => onReactionClick(reactionType)}
        />
      ))}
    </div>
  );
};

export default AvailableReactions;
